import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");
var Features = require("lib/account/Features");
var PaywallModal = require("components/users/teachers/PaywallModal");
var Glyphicon = require("components/utility/icons/Glyphicon");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

import DatePicker from 'react-datepicker';
import moment from 'moment';

require("users/teachers/cloze_customizer.scss");

@connect(
	(state, props) => {
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});
			return dispatch(RosterActions.updateAllStudentListPrefs({
				currentUserID: CurrentUser.get().id,
				update: prefsUpdate
			}))
		}
	})
)

@providePopulateData({waitForLoad:true})
class ClozeCustomizer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, clozeTestDates: props.prefs.cloze_test_dates,
			changesPending: false,
		};
		LuckyOrangeClient.tagComponent("ClozeCustomizer");
	}

	handleSubmit(e) {
		$wr.nope(e)

		if (!this.clozeAssessmentsEnabled()) {
			this.showPaywall();

		} else {
			this.setState({ loading: true });

			var preferenceHash = {
				cloze_test_dates: _.uniq(this.state.clozeTestDates)
			};
			var successText = "You have successfully updated your cloze assessment dates.";
			this.props.onChange(preferenceHash, successText).then(() => {
				this.setState({ loading: false, changesPending: false });
			});

		}
	}

	clozeAssessmentsEnabled() {
		return Features.isEnabled(Features.CLOZE_ASSESSMENTS);
	}

	showPaywall(e) {
		$wr.nope(e)
		this.refs.paywallModal.show();
	}

	addTestDateRow(e) {
		$wr.nope(e);
		this.selectTestDate(this.state.clozeTestDates.length, $wr.momentInTimezone());
	}
	removeTestDateRow(index) {
		if (!this.clozeAssessmentsEnabled()) {
			this.showPaywall();

		// we should never get here because link is disabled if only 1 test date, but just in case
		} else if (this.state.clozeTestDates.length == 1) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Sorry!", text: "We need at least one cloze assessment date.", 
				icon: "exclamation-sign", type: "error" 
			});

		} else {
			var newDatesArray = _.clone(this.state.clozeTestDates)
			newDatesArray.splice(index, 1);
			this.setState({ clozeTestDates: newDatesArray, changesPending: true });

		}
	}

	selectTestDate(dateIndex, testDate) {
		if (!this.clozeAssessmentsEnabled()) {
			this.showPaywall();
		} else {
			var newDatesArray = _.clone(this.state.clozeTestDates);
			newDatesArray[dateIndex] = moment(testDate).format("YYYY-MM-DD");
			this.setState({ clozeTestDates: newDatesArray, changesPending: true });
		}
	}

	render() {
		if (this.clozeAssessmentsEnabled()) {

			var clozeHeaderContent = (
				<p className="clozeInstructions">
					Select the dates you want your students to start testing with cloze assessments to
					get their updated reading levels.
				</p>
			);

			var testDateRows = _.map(this.state.clozeTestDates, function(testDate, index) {
				if (this.state.clozeTestDates.length > 1) {
					var removeRowLink = (
						<a href="#" className="removeRowLink"
							onClick={ this.removeTestDateRow.bind(this, index) } >
							<Glyphicon icon="minus-sign" />
						</a>
					);
				}
				return (
					<div key={ "testDateRow" + index }>
						<DatePicker className="testDatePicker"
							onChange={ this.selectTestDate.bind(this, index) } readOnly={ true }
							selected={ moment(testDate) } />
						{ removeRowLink }
					</div>
				);
			}.bind(this));

			var addRowLink = (
				<a href="#" onClick={ this.addTestDateRow }>
					<Glyphicon icon="plus-sign" /> Add Test Date
				</a>
			);

			if (this.state.changesPending) {
				var saveChangesButton = (
					<LoadingButton className="buttonSuccess center-block" text="Save Changes"
						loading={ this.state.loading } />
				);
			}

			return (
				<div className="clozeCustomizerContainer">
					{ clozeHeaderContent }
					<form className="clozeTestDatesForm" onSubmit={ this.handleSubmit }>
						{ testDateRows }
						{ addRowLink }
						{ saveChangesButton }
					</form>
				</div>
			)

		} else {

			var paywallModal = ( 
				<PaywallModal ref="paywallModal" featureType={ PaywallModal.CLOZE_ASSESSMENTS } /> 
			);

			var previewMessage = (
				<div className="previewMessage">
					<p className="message">
						Use <em>Reading Level Diagnostics</em> to automatically assess
						your students' reading levels.
					</p>
					<img onClick={ this.showPaywall } className="previewImage clickableElement"
						src={ require("paywalls/cloze-category-and-passage.gif") } />
					<p>
						<a href="#" className="btn buttonSuccess" onClick={ this.showPaywall }>
							Learn More
						</a>
					</p>
				</div>
			)

			return (
				<div className="clozeCustomizerContainer">
					{ previewMessage }
					{ paywallModal }
				</div>
			)

		}
	}

}

ClozeCustomizer.WrappedComponent.propTypes = StrictPropTypes({
	clozeTestDates: PropTypes.array,
	onChange: PropTypes.func.isRequired
});

module.exports = ClozeCustomizer;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/ClozeCustomizer.js